import { AdminPayrollTypePackageLoading } from '@/views/admin-payroll-type-package/admin-payroll-type-package.loading';

export default AdminPayrollTypePackageLoading;
